export interface DashboardAnalyticsModel {
    totalUsers: number;
    activeAdminUsers: number;
    bbActiveAdminUsers: number;
    llttfActiveAdminUsers: number;
    bbCoachedParticipants: number;
    bbSelfGuidedParticipants: number;
    llttfParticipants: number;
    organizations: number;
    courses: number;
    materials: number;
    llttfInvitationsNotAcceptedCount: number;
    llttfInvitationsExpiringCount: number;
    llttfInvitationsExpiredCount: number;
}

export function DashboardAnalyticsDefaultValues(): DashboardAnalyticsModel {
    return {
        totalUsers: 0,
        activeAdminUsers: 0,
        bbActiveAdminUsers: 0,
        llttfActiveAdminUsers: 0,
        bbCoachedParticipants: 0,
        bbSelfGuidedParticipants: 0,
        llttfParticipants: 0,
        organizations: 0,
        courses: 0,
        materials: 0,
        llttfInvitationsNotAcceptedCount: 0,
        llttfInvitationsExpiringCount: 0,
        llttfInvitationsExpiredCount: 0
    };
}
